module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sbox"
  }, [_c('h2', {
    staticClass: "subchapter",
    attrs: {
      "id": "s009"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#s9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chicken Ranch Hash Brown Casserole")])])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/21-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Yield: Serves 2 | Prep Time: 15 minutes | Cook Time: 30 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "recipenote"
  }, [_vm._v("The first moment when your fork punctures the yolk is the start of a delicious meal as the ooey-gooeyness coats the rest of the dish, acting as a last-minute sauce. Crispy ranch hash browns and chicken make for a hearty breakfast, one that happens to be a perfect dish for two.")])]), _vm._v(" "), _c('p', {
    staticClass: "serves"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "indger1"
  }, [_vm._v("1 cup canned cream of chicken soup")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("3 tablespoons sour cream")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("2 ounces cream cheese, room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("2 tablespoons whole milk")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 tablespoon ranch dressing and seasoning mix")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("3 drops Tabasco, plus extra for serving")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("Salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("2 cups frozen hash browns with bell pepper and onion, thawed")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("1 boneless, skinless chicken breast, cooked and shredded, approximately 1 cup when shredded")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("½ cup shredded cheddar cheese")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("2 teaspoons unsalted butter, melted")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("2 large eggs")]), _vm._v(" "), _c('p', {
    staticClass: "indger"
  }, [_vm._v("Fresh parsley, for garnish (optional)")]), _vm._v(" "), _c('h2', {
    staticClass: "Directions"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("1. Preheat the oven to 350°F and lightly coat an 8 × 8-inch baking dish with cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("2. In a medium bowl combine the soup, sour cream, cream cheese, milk, ranch mix, Tabasco, and ¼ teaspoon pepper. Stir to mix, then add the hash browns, chicken, and cheese. Spoon into the baking dish and bake for 30 minutes, until the mixture is bubbling and the top is lightly browned.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_vm._v("3. In a small skillet, melt the butter over medium heat, then crack the eggs into the pan and season with salt and pepper. After 3 minutes, when the eggs begin to whiten, flip them. Divide the casserole between two plates, top each portion with a fried egg, and serve, garnished with fresh parsley if desired.")]), _vm._v(" "), _c('h2', {
    staticClass: "headn"
  }, [_c('strong', [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("For the chicken, use leftovers from dinner or a rotisserie chicken from the store.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b8eaa68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/s009.vue
// module id = 108
// module chunks = 0